/*
* Author: GM
* Component: TempHelper
*/


!function ($) {
    "use strict";

    var TempHelper = function () {
        this._cache = {};
    };


    /* Initializing */
    TempHelper.prototype.init = function () {
        console.log('TempHelper.Initializing');
    };


    TempHelper.prototype.get = function (name, data, callback) {
        var $this = this;

        if (name in $this._cache) {
            $this.render(name, data, callback);
        } else {
            $.get(U + 'assets/html/' + name + '.html', function (html) {

                if (name in $this._cache) {
                    $this.render(name, data, callback);
                } else {
                    $this._cache[name] = Handlebars.compile(html);
                    $this.render(name, data, callback);
                }
            });
        }
    };

    TempHelper.prototype.render = function (name, data, callback) {
        console.log('TempHelper.render.' + name, data);

        if ($.isFunction(callback))
            callback(this._cache[name](data));
    };


    //init RangeSlider
    $.TempHelper = new TempHelper;
    $.TempHelper.Constructor = TempHelper;
}(window.jQuery),

    //initializing TempHelper
    function ($) {
        "use strict";
        $.TempHelper.init();
    }(window.jQuery);



var TEMP = {
    _GET: function (name, data, callback) {


        if (name in this) {
            TEMP._RENDER(name, data, callback);
        } else {

            var htmlTemplate = LS.TEMP.get(name);
            if (htmlTemplate) {

                TEMP[name] = Handlebars.compile(htmlTemplate);
                TEMP._RENDER(name, data, callback);

            } else {

                $.get(Ul + 'ajax/template/' + name, function (html) {

                    if (name in TEMP) {
                        TEMP._RENDER(name, data, callback);
                    } else {
                        LS.TEMP.set(name, html);
                        TEMP[name] = Handlebars.compile(html);
                        TEMP._RENDER(name, data, callback);
                    }
                });

            }
        }
    }
};